import type { FaireProductEntity } from "../../entity_types/product";

export const p_235ps9ucgu: FaireProductEntity = {
  token: "p_235ps9ucgu",
  type: "product",
  name: "Crisp Apple",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/a581c3be439f17347ae26689d9d69ff71eb998cb21e1d21773ff7b8d65897b00.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee1ba4d305e355d725679c033d334daa8a973179f794ddc2f32187169f5dde69.png",
    "https://cdn.faire.com/fastly/f3b3e223a40564cf0ac29aeda03f85e4aa01c8b18b2dcb7a7f8da65c984fd97a.png",
    "https://cdn.faire.com/fastly/53609ddc0d3add66b9d06e58b00b7fb75d65474f15574ef881892ff77082df13.png",
    "https://cdn.faire.com/fastly/966faa42e71694dcb1b4d9f04b7223dc02904edc71cde5fc819892086bd90a6e.png",
    "https://cdn.faire.com/fastly/b6e931e7caaa36705ea238f21520e93332086c1b0a5db074fafbb791cb6e0472.png",
    "https://cdn.faire.com/fastly/86cb60669ae77cb42ef3792bf61aac4800d73b51c4884a30154aae93c6a45aa0.png",
  ],
  priceDollars: 28.99,
  description:
    "Like sparkling apple juice and gummy apple rings blended together, Crisp Apple is tantalizingly sweet and oh so refreshing. It makes every day feel like a celebration.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:09.472Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
